import Controller from '@ember/controller';
import { computed, get } from '@ember/object';
import { equal, sort } from '@ember/object/computed';
import { service } from '@ember/service';

export default Controller.extend({
  settings: service(),

  sortBy: ['fund.name:asc'],
  sortedFunds: sort('model.fundPermissions', 'sortBy'),

  userCanViewAllFunds: equal('model.user.role', 'Org-Admin'),

  canOverrideRolePerFund: computed(function () {
    return get(this, 'settings.orgSettings.canOverrideRolePerFund');
  }),
});
